import config from '@/config';
import { usePageContext } from '@/src/composables/usePageContext';
import { type App } from 'vue';

async function getMeta(vm: any) {
  const { meta } = vm.$options;
  if (meta) {
    return typeof meta === 'function' ? await meta({ config, pageContext: usePageContext(), self: vm }) : meta;
  }
  return null;
}

export const MetaInfoPlugin = {
  install: (app: App) => {
    if (!import.meta.env.SSR) {
      app.mixin({
        async updated() {
          const meta = await getMeta(this);
          if (meta) {
            document.title = meta.title;
            document.querySelector('meta[name=description]')?.setAttribute('content', meta.description);
          }
        },
      });
    }
  },
};
